/**
 * The trainer-only refusal state. Reachable only while the session is `refused`, so a deep link here
 * from a signed-out browser lands on sign-in instead of on an explanation of a rejection that never
 * happened.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

import { sessionRedirectFrom } from '~/entities/session';
import { TrainerOnlyRefusalScreen } from '~/pages/refused';

export const Route = createFileRoute('/refused')({
  beforeLoad: () => {
    const destination = sessionRedirectFrom('/refused');
    // `throw: true` makes `redirect` raise the router's own Response itself. A bare `throw
    // redirect(...)` throws a non-Error, which is exactly what `only-throw-error` is there to catch.
    if (destination !== null) redirect({ to: destination, replace: true, throw: true });
  },
  component: TrainerOnlyRefusalScreen,
});
